// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2ECIe","savePackageButton":"ClientWallet_savePackageButton__cFXrV"};